<template>
    <section class="about_contact mt-6">
        <v-container>
        <v-row
        align="center"
        class="fill-height"
        style="height:250px"
        >
          <v-col
           cols="12"
           sm="7"
           md="6"
          >
          <h2 style="font-size:22pt" class="white--text text-capitalize" v-html='$t("aboutUs.contactUsText")'></h2>
          </v-col>
          <v-col
           cols="12"
           sm="5"
           md="6"
          >
          <v-btn link to="/contact">{{$t("aboutUs.contactUs")}}</v-btn>
          </v-col>
        </v-row>
        </v-container>
    </section>
</template>

<script>
export default {
    name:'about_contact'
}
</script>

<style lang="scss">
    .about_contact{
        background-color: #42378f;
background-image: linear-gradient(315deg, #42378f 0%, #f53844 74%);
    }
</style>